import api from "../api/client";

function getFileNameFromDisposition(dispositionHeader, fallbackFileName) {
  const disposition = String(dispositionHeader || "");
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const fileNameMatch = disposition.match(/filename="?([^"]+)"?/i);
  if (fileNameMatch?.[1]) {
    return fileNameMatch[1];
  }

  return fallbackFileName;
}

export function downloadBlob(blob, fileName) {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName || "download";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}

export async function downloadApiFile(url, options = {}) {
  const { params, fallbackFileName = "download.csv" } = options;
  const response = await api.get(url, {
    params,
    responseType: "blob"
  });

  const fileName = getFileNameFromDisposition(response.headers["content-disposition"], fallbackFileName);
  downloadBlob(response.data, fileName);
}
